import getContactService from './contact';
export const contactService = getContactService();
export const services = [contactService.service];
